import 'date-fns';
import React, { useState, useEffect } from 'react';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';

export default function DatePicker({
  value,
  name,
  label,
  disabled,
  handleDateChange,
  onChange,
  error,
  minDate,
  maxDate,
}) {
  const [selectedDate, setSelectedDate] = useState(value || new Date());

  useEffect(() => {
    setSelectedDate(value || new Date());
  }, [value]);

  const handleDateChangeLocal = (date) => {
    setSelectedDate(date);
    handleDateChange && handleDateChange(name, date);
    onChange && onChange(date);
  };

  return (
    <div className="mt-2" style={{ textAlign: 'center' }}>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <KeyboardDatePicker
          margin="none"
          id={`date-picker-dialog-${name}`}
          label={label}
          format="dd/MM/yyyy"
          value={selectedDate}
          onChange={handleDateChangeLocal}
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
          variant="inline"
          name={name}
          disabled={disabled}
          autoOk={true}
          minDate={minDate}
          maxDate={maxDate}
          minDateMessage={
            'Рок важења не сме бити мањи од датума почетка употребе!'
          }
        />
      </MuiPickersUtilsProvider>
      {error && (
        <b>
          <div style={{ color: 'red' }}>{error}</div>
        </b>
      )}
    </div>
  );
}
